import React, {FC, useMemo} from 'react';
import {ApolloProvider} from '@apollo/client';
import {API} from '../classes/API';
import {createApolloClient} from './graphql';
import {getEnvironmentConfig} from '../utils/config';

export const ApiClientProvider: FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const config = getEnvironmentConfig();
  const supabaseClient = API.getInstance().supabaseClient;

  const apolloClient = useMemo(
    () =>
      createApolloClient({
        baseUrl: config.supabase.url,
        apiKey: config.supabase.anonKey,
        supabaseClient,
      }),
    [config.supabase.url, config.supabase.anonKey, supabaseClient],
  );

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
